import React, { useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LocalizedText from '@LocalizedText';
import useIntlMessage from '@app/hooks/use-intl-message';
import './RenameDesign.scss';

const RenameDesign = ({
  artworkInfo: {
    name,
    preview_urls: { large: previewUrl },
  },
  setDesignName,
  designName,
}) => {
  const [renameDesignAriaLabel] = useIntlMessage('qau-design-name-aria-label');
  const { current: imageHash } = useRef(Date.now());
  const nameInputRef = useRef();

  const setCursorPosition = useCallback(() => {
    const { current = {} } = nameInputRef;
    current.selectionStart = designName.length;
    current.selectionEnd = designName.length;
    current.focus();
  }, [designName]);

  useEffect(setCursorPosition, []);

  const onNameChanged = ({ target: { value = '' } }) => {
    const name = value.replace(/(\s)\s+/, '$1');
    setDesignName(name);
  };

  return (
    <div id="rename-zone">
      <div>
        <div className="rename-title">
          <LocalizedText id="qau-rename-title" />
        </div>
        <input
          type="text"
          name="renameDesign"
          aria-label={renameDesignAriaLabel}
          ref={nameInputRef}
          value={designName || ''}
          onChange={onNameChanged}
        />
      </div>
      <div className="artwork-preview">
        <img src={`${previewUrl}?hash=${imageHash}`} alt="Artwork Preview" />
      </div>
    </div>
  );
};

const mapStateToProps = ({ artwork }) => ({
  artworkInfo: artwork.info,
});

RenameDesign.propTypes = {
  artworkInfo: PropTypes.object.isRequired,
  designName: PropTypes.string.isRequired,
  setDesignName:  PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(RenameDesign);
